import { getField, updateField } from 'vuex-map-fields';
import { client } from "@/api/client";

export const SET_LOCATIONS = "SET_LOCATIONS";
export const SET_CDBTYPES = "SET_CDBTYPES";

const state = () => ({
    headers: [
        {
            align: 'start',
            text: 'Programa contable',
            value: 'cdb_type_name',
            sortable: false,
        },
        {
            text: 'Nombre',
            value: 'name',
            sortable: false,
        },
        // {
        //     text: 'Tipo',
        //     values: 'location_type__name',
        //     sortable: false,
        // },
        {
            text: 'Ruta',
            value: 'path',
            sortable: false,
        },
    ],
    location_id: '',
    name: '',
    path: '',
    cdb_type: '',
    cdb_types: [],
    locations: [],
});

const getters = {
    getField,
}

const mutations = {
    updateField,
    [SET_CDBTYPES](state, cdb_types) {
        state.cdb_types = cdb_types;
    },
    [SET_LOCATIONS](state, locations) {
        state.locations = locations;
    },
}

const getCdbTypes = ({ commit }) => {
    return new Promise((resolve, reject) => {
        client.get('get_locations_companydb_types/').then(response => {
            commit(SET_CDBTYPES, response.data['companydb_types']);
            resolve();
        }).catch(err => {
            console.error(err);
            reject();
        });
    });
}

const getLocations = ({ commit }) => {
    return new Promise((resolve, reject) => {
        client.get('get_locations/').then(response => {
            commit(SET_LOCATIONS, response.data['results']);
            resolve();
        }).catch(err => {
            console.error(err);
            reject();
        });
    });
}

const createLocation = ({ state }) => {
    return new Promise((resolve, reject) => {
        let params = {
            'cdb_type': state.cdb_type,
            'name': state.name,
            'path': state.path,
        };
        client.post('create_location/', params).then(() => {
            resolve();
        }).catch(err => {
            console.error(err);
            reject();
        });
    });
}

const updateLocation = ({ state }) => {
    return new Promise((resolve, reject) => {
        let params = {
            'id': state.location_id,
            'name': state.name,
            'cdb_type': state.cdb_type,
            'path': state.path,
        };
        client.patch('update_location/', params).then(() => {
            resolve();
        }).catch(err => {
            console.error(err);
            reject();
        });
    });
}

const deleteLocation = ({ state }) => {
    return new Promise((resolve, reject) => {
        client.patch('delete_location/', { 'id': state.location_id }).then(() => {
            resolve();
        }).catch(err => {
            console.error(err);
            reject();
        });
    });
}

const actions = {
    getCdbTypes,
    getLocations,
    createLocation,
    updateLocation,
    deleteLocation,
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}